"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ActionType;
(function (ActionType) {
    ActionType["Edit"] = "Edit";
    ActionType["Add"] = "Add";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ColorEditor = (function (_super) {
    __extends(ColorEditor, _super);
    function ColorEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.colorInputValue = "";
        _this.getInitialColorValue = function (props) {
            var initialColorValue = props.initialColorValue, selectionColors = props.selectionColors;
            if (initialColorValue && (0, ColorUtils_1.isValidColor)(initialColorValue)) {
                return (0, ColorUtils_1.getHex)(initialColorValue);
            }
            else {
                return (0, ColorUtils_1.getHex)(selectionColors[0].value);
            }
        };
        _this.getColorIndex = function (initialColor, props) {
            var colorValueIndex = (0, lodash_1.findIndex)(props.selectionColors, function (color) {
                return (0, ColorUtils_1.areColorsEqual)(color.value, initialColor);
            });
            return colorValueIndex >= 0 ? colorValueIndex : null;
        };
        _this.handleColorChange = function (color) {
            var colorValue = (0, ColorUtils_1.getHex)(color.value);
            _this.colorInputValue = colorValue;
        };
        _this.handleCompleteEdit = function () {
            _this.props.handleActionComplete(_this.colorInputValue);
        };
        _this.handleDeleteColor = function () {
            if (_this.props.handleDeleteColor) {
                _this.props.handleDeleteColor();
            }
        };
        _this.colorInputValue = _this.getInitialColorValue(props);
        return _this;
    }
    ColorEditor.prototype.render = function () {
        var _a = this.props, selectionColors = _a.selectionColors, actionType = _a.actionType;
        var _b = this, containerTitle = _b.containerTitle, buttonLabel = _b.buttonLabel;
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "color-editor" },
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" },
                        react_1.default.createElement("div", { className: "color-editor__title-container" },
                            containerTitle,
                            actionType === ActionType.Edit && (react_1.default.createElement("div", { className: "color-editor__delete", onClick: this.handleDeleteColor },
                                react_1.default.createElement(icons_1.Delete, null)))))),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(ColorPalette_1.default, { presetColors: selectionColors, onColorChange: this.handleColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)({
                                value: this.colorInputValue,
                                themeIndex: this.getColorIndex(this.colorInputValue, this.props),
                            }, selectionColors), type: "brand" }))),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement(kaleidoscope_1.Button, { width: "full", onClick: this.handleCompleteEdit }, buttonLabel)))));
    };
    Object.defineProperty(ColorEditor.prototype, "containerTitle", {
        get: function () {
            return this.props.actionType === ActionType.Edit ? "Edit color" : "Add color";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorEditor.prototype, "buttonLabel", {
        get: function () {
            return this.props.actionType === ActionType.Edit ? "Update color" : "Add color";
        },
        enumerable: false,
        configurable: true
    });
    ColorEditor.defaultProps = {
        actionType: ActionType.Edit,
        handleDeleteColor: lodash_1.noop,
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], ColorEditor.prototype, "colorInputValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ColorEditor.prototype, "handleColorChange", void 0);
    ColorEditor = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ColorEditor);
    return ColorEditor;
}(react_1.default.Component));
exports.default = ColorEditor;
